import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Global error handler for uncaught errors
window.onerror = function(message, source, lineno, colno, error) {
  console.error('Global error caught:', { message, source, lineno, colno, error });
  // Show visible error on screen if React hasn't mounted
  const rootEl = document.getElementById("root");
  if (rootEl && !rootEl.hasChildNodes()) {
    rootEl.innerHTML = `
      <div style="min-height:100vh;background:#0a0a0a;display:flex;align-items:center;justify-content:center;padding:24px;font-family:system-ui,-apple-system,sans-serif">
        <div style="max-width:500px;text-align:center;color:white">
          <h1 style="font-size:24px;margin-bottom:16px">Application Error</h1>
          <p style="color:#888;margin-bottom:16px">${message}</p>
          <p style="color:#666;font-size:12px;margin-bottom:24px">Source: ${source}:${lineno}</p>
          <button onclick="location.reload()" style="background:#7c3aed;color:white;padding:12px 24px;border:none;border-radius:8px;cursor:pointer">
            Refresh Page
          </button>
        </div>
      </div>
    `;
  }
  return false;
};

// Catch unhandled promise rejections
window.onunhandledrejection = function(event) {
  console.error('Unhandled promise rejection:', event.reason);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
